import { basicAxios } from "../../sevices/baseAxios";

export const getAllInterfaces = async (data) => {
  const response = await basicAxios.get(
    `/api/Interface/GetAllInterfaces?pageSize=${data?.pageSize}&pageIndex=${data?.pageIndex}`
  );
  return response.data;
};

export const addNewInterface = async (data) => {
  // console.log(data, "ADDD")

  const dt = {
    "id": 0,
    "name": "asfads",
    "folderId": 100,
    "repositoryFolderId": 100,
    "accessKey": "adsf",
    "storage": "10",
    "status": true,
    //"createdDate": "2023-05-12T14:17:50.818Z"
  }

  const response = await basicAxios.post("/api/Interface/AddInterface", data);
  return response.data;
};

export const addNewInterfaceFilter = async (data) => {
  const response = await basicAxios.post("/api/Interface/FilterInterfaces", data);
  return response.data;
};

export const getStatusAllInterfaces = async (data) => {
  const response = await basicAxios.patch("/api/Interface/UpdateInterfaceStatus", data);
  return response.data;
};

export const getDeleteAllInterfaces = async (id) => {
  const response = await basicAxios.delete(`/api/Interface/DeleteInterfaceById?id=${id}`);
  return response.data;
};

export const getInterfaceDocumentFolders = async () => {
  const response = await basicAxios.get("/api/Interface/GetInterfaceDocumentFolder");
  return response.data;
};

export const getInterfaceRepoFolder = async () => {
  const response = await basicAxios.get("/api/Interface/GetInterfaceRepoFolder");
  return response.data;
};
